import { ItemSize } from "../types/components";

export const getFontSize = (size: ItemSize): number => {
  switch (size) {
    case "extraSmall":
      return 8;
    case "small":
      return 10;
    case "medium":
      return 12;
    case "large":
      return 14;
    case "extraLarge":
      return 16;
    default:
      return 12;
  }
};
